export const AUTH_STORAGE_KEY = 'auth';
